import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateRoute } from "../../api/routes";

export function useUpdateRoute() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateRoute,
    onSuccess: () => {
      console.log("Route updated successfully");
      queryClient.invalidateQueries({ queryKey: ["routes"] });
    },
    onError: (err) => console.error("Error updating route:", err),
  });
}